export default "__VITE_ASSET__DdYHiuvC__"